import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LeadSourceService {

  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/leadSource";

  ur2 = environment.serverAPI9 + "/api/leadActivity";

  url1 = environment.serverAPI4 + "/api/eavattribute";


  newLeadSource(lead: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, lead)
  }

  getLeadById(sourceId: number): Observable<Object> {
    return this.http.get(`${this.url}/${sourceId}`);
  }

  LeadSource(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllLeadSourceDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getAllActivityTypeDropDown(): Observable<Object> {
    return this.http.get(`${this.ur2}/dropdown`);
  }

  getAllActivityTypeDropDownNew(): Observable<Object> {
    return this.http.get(`${this.ur2}/dropdown/new`);
  }

  leadSourceSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {
    const encodedQuery = query != null ? encodeURIComponent(query) : '';
    return this.http.get(`${this.url}/filter?search=${encodedQuery}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getDropDown(entityTypeId: number) {
    return this.http.get(`${this.url1}/type/${entityTypeId}`);
  }
  syncLeadSourcePageData() {
    return this.http.get(`${this.url}/page/sync`);
  }

  getDropDownOnly1(entityTypeId: number) {
    return this.http.get(`${this.url1}/type/${entityTypeId}/only/new`);
  }


  NameVerified(sourceName: any): Observable<Object> {
    return this.http.get(`${this.url}/sourceName/${sourceName}`);
  }

}
